(() => {
  const MOTION_KEY = 'furavoraMotionV1';
  const root = document.documentElement;
  const reducedMedia = window.matchMedia('(prefers-reduced-motion: reduce)');
  let motionPreference = null;
  let searchPositionFrame = 0;

  const readPreference = () => {
    try {
      return localStorage.getItem(MOTION_KEY) === 'reduce' ? 'reduce' : 'auto';
    } catch (_error) {
      return 'auto';
    }
  };

  const savePreference = (value) => {
    try {
      localStorage.setItem(MOTION_KEY, value);
    } catch (_error) {
      // The setting still works for this page when browser storage is unavailable.
    }
  };

  const currentMotionPreference = () => {
    if (!motionPreference) motionPreference = readPreference();
    return motionPreference;
  };

  const syncMotionControls = (preference, effectiveReduced) => {
    document.querySelectorAll('[data-fv-motion-toggle]').forEach((button) => {
      button.setAttribute('aria-checked', String(preference === 'reduce'));
      button.setAttribute('aria-label', 'Reduce motion');
      button.dataset.fvMotionEffective = effectiveReduced ? 'reduce' : 'standard';
      const hint = button.querySelector('small');
      if (hint) {
        hint.textContent = preference === 'reduce'
          ? 'Extra motion reduction is on'
          : (effectiveReduced ? 'Following your device setting' : 'Calmer slides and transitions');
      }
    });
  };

  const applyMotion = (preference, persist = false) => {
    const nextPreference = preference === 'reduce' ? 'reduce' : 'auto';
    const shouldReduce = nextPreference === 'reduce' || (nextPreference === 'auto' && reducedMedia.matches);
    motionPreference = nextPreference;
    if (shouldReduce) root.dataset.fvMotion = 'reduce';
    else delete root.dataset.fvMotion;
    if (persist) savePreference(nextPreference);
    syncMotionControls(nextPreference, shouldReduce);
    document.dispatchEvent(new CustomEvent('furavora:motion-change', {
      detail: { preference: nextPreference, reduced: shouldReduce },
    }));
  };

  const syncSearchPosition = (search) => {
    if (!search?.open) return;
    const header = search.closest('[data-fv2-header]');
    if (!header) return;
    const headerBottom = header.getBoundingClientRect().bottom;
    search.style.setProperty('--fv-search-top', `${Math.max(8, Math.round(headerBottom + 8))}px`);
  };

  const queueOpenSearchPositions = () => {
    if (searchPositionFrame) return;
    searchPositionFrame = window.requestAnimationFrame(() => {
      searchPositionFrame = 0;
      document.querySelectorAll('[data-fv2-search][open]').forEach(syncSearchPosition);
    });
  };

  const initSettings = () => {
    applyMotion(currentMotionPreference(), false);

    document.querySelectorAll('[data-fv-motion-toggle]').forEach((button) => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.addEventListener('click', () => {
        applyMotion(currentMotionPreference() === 'reduce' ? 'auto' : 'reduce', true);
      });
    });

    document.querySelectorAll('[data-fv2-search]').forEach((search) => {
      if (search.dataset.fv265PositionReady) return;
      search.dataset.fv265PositionReady = 'true';
      search.addEventListener('toggle', () => {
        if (search.open) window.requestAnimationFrame(() => syncSearchPosition(search));
      });
      syncSearchPosition(search);
    });
  };

  const refreshAutoMotion = () => {
    if (currentMotionPreference() === 'auto') applyMotion('auto', false);
  };

  if (reducedMedia.addEventListener) reducedMedia.addEventListener('change', refreshAutoMotion);
  else reducedMedia.addListener(refreshAutoMotion);

  window.addEventListener('scroll', queueOpenSearchPositions, { passive: true });
  window.addEventListener('resize', queueOpenSearchPositions, { passive: true });
  window.visualViewport?.addEventListener('resize', queueOpenSearchPositions, { passive: true });
  window.visualViewport?.addEventListener('scroll', queueOpenSearchPositions, { passive: true });

  document.addEventListener('DOMContentLoaded', initSettings);
  document.addEventListener('shopify:section:load', initSettings);
})();
